import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PopupComponent } from './popup.component';
import { TranslationModule } from 'src/app/modules/translate.module';

@NgModule({
    declarations: [PopupComponent],
    imports: [CommonModule, RouterModule, TranslationModule],
    exports: [PopupComponent],
    providers: [PopupComponent],
})
export class PopupModule {}
